import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";

export default function MainLayout() {
    return (
        <div className="min-h-screen bg-navy text-white" data-testid="main-layout">
            <Navbar />
            <main className="relative">
                <Outlet />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
}
